import React from 'react';
import image from '../../../assets/images/logos/logoblue.svg';
import './Loader.scss';
const Loader =()=>{
    return(
        <div className="loader">
        <img src={image} alt='loader image'/>
        </div>
    )
};
export default Loader ;